var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"transform":"rotate(270 26 7)","key":0},React.createElement("path",{"fill":"none","stroke":"#ffffff","strokeLinecap":"square","strokeMiterlimit":"50","strokeWidth":"2","d":"M15-7v26"})),React.createElement("g",{"transform":"rotate(270 26 7)","key":1},React.createElement("path",{"fill":"none","stroke":"#ffffff","strokeMiterlimit":"50","strokeWidth":"2","d":"M9 15v0l6 6v0l6-6v0"}))]));
}

RightArrow.defaultProps = {"width":"55","height":"40","viewBox":"0 0 50 27"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
